import type { AnyAction, Dispatch } from 'redux';

import * as FindOrganizationNotificationTimeSettingsAPI from 'ab-api/web/organizationNotificationSettings/findOrganizationNotificationTimeSettings';
import * as UpdateOrganizationNotificationSettingsAPI from 'ab-api/web/organizationNotificationSettings/updateOrganizationNotificationTimeSettings';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import type { OrganizationNotificationType } from 'ab-enums/organizationNotificationType.enum';

export function findOrganizationNotificationTimeSettings(type: OrganizationNotificationType) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http
				.get<FindOrganizationNotificationTimeSettingsAPI.W_OrganizationNotificationSettings_FindOrganizationNotificationTimeSettings_VM>(
					FindOrganizationNotificationTimeSettingsAPI.URL(type)
				);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function updateOrganizationNotificationTimeSettings(
	type: OrganizationNotificationType,
	rm: UpdateOrganizationNotificationSettingsAPI.W_OrganizationNotificationSettings_UpdateOrganizationNotificationTimeSettings_RM
) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.put(UpdateOrganizationNotificationSettingsAPI.URL(type), rm);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
